import {createHelpers} from 'vuex-map-fields';
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";
import executePromises from "../../helpers/executePromises.js";
import {setStatesLoadingList} from "../../helpers/setStatesLoadingList";
import cloneData from "../../mixins/cloneData";
import orders from "./orders";
import {PromiseWorker} from "../../helpers/promiseWorker";

const {getStopListField, updateStopListField} = createHelpers({
    getterType: 'getStopListField',
    mutationType: 'updateStopListField',
});

const state = {
    selectAggregatorsLocationsRest: [],
    selectRestId: null,
    stopListProducts: [],
    selectProductsStopList: [],
    searchDataStopListRest: '',
    searchDataStopListFast: '',
    searchProductsMenuStopList: [],
    stopListProductsFilter: [],
    stopListProductsTotal: 0,
    stopListProductsTotalSizeScrollBlock: 0,
    stopListProductsSizeItemBlock: 71,
    stopListProductsLoadCount: 0,
    stopListChunkSize: 30,
    stopListGroups: [
        {id: 1, const: 'O.GROUPING_BY_RESTAURANTS', type_data: '', isSelect: true},
        {id: 2, const: 'O.FAST_STOP_LIST', type_data: '', isSelect: false},
        {id: 3, const: 'O.WITHOUT_GROUPING', type_data: '', isSelect: false}
    ],
    activeItemStopListGroups: null,
    isLoadedStopListProductsWithoutFilter: false,
    isLoadedStopListRestaurantsLocations: false,
    stopListFilterRestaurantsLocations: [],
    stopListProductsWithoutFilter: [],
    totalPagesStopListProducts: 0,
    limitEntriesOnPage: 0,
    filterStopList: {
        location: 0,
        restaurant: 0,
        activePage: 1,
        isFilter: false,
        filter: {
            search: ''
        },
        list: {
            limit_start: 0,
            limit: 30,
            direction: 'DESC',
            ordering: 'added'
        }
    },
    selectAggregatorsLocationsAll: [],
    isLoadedSelectAggregatorsLocationsAll: false,
}
const actions = {
    async STOP_LIST_DATA({commit}, restId) {
        try {
            const paramsStopList = {
                "list": {"limit_start": 0, "limit": state.stopListChunkSize * 2}
            }
            const requests = [
                $api.get('/internal/aggregators/locations/select/rest/' + restId),
                $api.post('/internal/catalog/stop_list/' + restId, paramsStopList),
            ]
            const responses = await Promise.all(requests);
            const results = responses.map(({data}) => data);
            commit('setInitFilter', restId);
            commit('setStopListData', results);
        } catch (error) {
            errorOutput(__t('O.FAILED_TO_GET_INFORMATION_STOP_LIST'), error, 'stopListData');
            console.log('Error request data:', error);
            EventBus.$emit('load_stop_list_data');
        }
    },
    STOP_LIST_PRODUCTS_BY_REST_LOAD({commit}, params) {
        $api.post('/internal/catalog/stop_list/' + state.selectRestId, params)
            .then(({data}) => {
                params.data = data.data;
                commit('stopListProductsByRestLoad', params);
            })
            .catch(error => {
                errorOutput(__t('O.FAILED_TO_GET_INFORMATION_STOP_LIST'), error, 'stopListData');
                console.log('Error request data:', error);
                EventBus.$emit('stop_list_products_by_rest_load');
            })
    },
    async STOP_LIST_PRODUCTS_WITHOUT_FILTER({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'stopListProductsWithoutFilter',
                url: '/internal/catalog/stop_list_products',
                paramsUrl: {},
                method: 'POST',
                body: params.body,
            },
        )

        const props = {
            commit: commit,
            commitName: 'getStopListProductsWithoutFilter',
            nameError: 'O.FAILED_TO_GET_STOP_LIST_PRODUCTS',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
    async STOP_LIST_RESTAURANTS_LOCATIONS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'stopListFilterRestaurantsLocations',
                url: '/internal/catalog/stop_list_products/rest_locations',
                paramsUrl: {},
                method: 'GET',
                body: null,
            },
        )

        const props = {
            commit: commit,
            commitName: 'stopListRestaurantsLocations',
            nameError: 'O.FAILED_TO_GET_LIST_RESTAURANTS_LOCATIONS',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
    SET_SELECT_PRODUCTS_STOP_LIST({commit}, productsList) {
        commit('setSelectProductsStopList', productsList);
    },
    SEARCH_PRODUCTS_MENU({commit}, params) {
        let body = {};
        if(params.restId) {
            body = {rest_id: parseInt(params?.restId)};
        }
        const searchString = params.isSearchModifier ? 'mod:' + params.searchData : params.searchData;
        $api.post('/internal/catalog/menu/suggest/' + searchString, body)
            .then(({data}) => {
                if (data.status && data.status !== 'operation_fail') {
                    if(params.restId) {
                        commit('setSearchDataStopListRest', params.searchData);
                    } else {
                        commit('setSearchDataStopListFast', params.searchData);
                    }
                    commit('menuSearchProductsMenu', data.data);
                } else {
                    errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), data, params.actionName);
                    EventBus.$emit('load_search_products_menu');
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), err, params.actionName);
                EventBus.$emit('load_search_products_menu');
            })
    },
    CLEAR_SEARCH_STOP_LIST_REST({commit}) {
        commit('clearSearchStopListRest');
    },
    CLEAR_SEARCH_STOP_LIST_FAST({commit}) {
        commit('clearSearchStopListFast');
    },
    SET_ACTIVE_ITEM_STOP_LIST_GROUPS({commit}, itemGroups) {
        commit('setActiveItemStopListGroups', itemGroups);
    },
    SET_STATES_LOADING_LIST({commit}, params) {
        commit('setStatesLoadingList', params);
    },
    async GET_FILTER_STOP_LIST({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'filterStopList',
                url: '/internal/catalog/stop_list_products/filter',
                paramsUrl: {},
                method: 'GET',
                body: null,
            },
        )

        const props = {
            commit: commit,
            commitName: 'getDataFilterStopList',
            nameError: 'O.FAILED_TO_GET_FILTER_STOP_LIST',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
    async STOP_LIST_PRODUCTS_ACTION({commit}, params) {
        const requests = [];
        params.products.forEach(item => {
            const {uniq_id, id, title} = item.product;
            const productRequest = {
                uniq_id: uniq_id,
                id: id,
                title: title,
                amount: 0,
                action: params.action
            }
            requests.push(
                {
                    requestName: item?.product?.title,
                    url: '/internal/locations/{locationId}/stop_list/{action}',
                    paramsUrl: {
                        locationId: item.location.id,
                        action: params.action,
                    },
                    method: 'POST',
                    body: {
                        products: [
                            productRequest
                        ]},
                },
            )
        })

        const props = {
            commit: commit,
            commitName: 'stopListProductsAction',
            nameError: 'O.FAILED_TO_STOP_LIST_PRODUCT_ACTION',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
    async SELECT_AGGREGATORS_LOCATIONS_ALL({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'selectAggregatorsLocationsAll',
                url: '/internal/aggregators/locations/select/all',
                paramsUrl: {},
                method: 'GET',
            },
        )

        const props = {
            commit: commit,
            commitName: 'setSelectAggregatorsLocationsAll',
            nameError: 'O.FAILED_TO_GET_AGGREGATORS_LOCATIONS_SELECT_ALL',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
}

const mutations = {
    updateStopListField,
    stopListProductsByRestLoad(state, params) {
        if (params.data && Array.isArray(params.data.data)) {
            params.data.data.forEach(item => {
                item.isCheck = false;
                state.stopListProducts.push(item);
            });
            if (params.list && params.list.limit_start && params.list.limit) {
                state.stopListProductsLoadCount = params.list.limit_start + params.list.limit;
            }
        }
        EventBus.$emit('stop_list_products_by_rest_load');
    },

    clearSearchStopListRest(state) {
        state.searchDataStopListRest = '';
        state.searchProductsMenuStopList = [];
        state.stopListProductsFilter = [];
    },
    clearSearchStopListFast(state) {
        state.searchDataStopListFast = '';
        state.searchProductsMenuStopList = [];
        state.stopListProductsFilter = [];
    },

    setActiveNewOrderId(state, idNewOrder) {
        state.newOrderId = idNewOrder;
    },
    setInitFilter(state, restId) {
        state.selectRestId = restId;
        let rest = orders.state.posRestaurantsList.find(item => item.id === parseInt(restId));
        if (rest.attached_locations && Array.isArray(rest.attached_locations)) {
            rest.attached_locations.forEach(item => {
                item.isCheck = false;
                item.isCheckSave = false;
                item.isCheckProductStopList = false;
            })
            rest.attached_locations.forEach(item => state.stopListProductsFilter.push({...item}));
        }
    },
    setStopListData(state, results) {
        if (!Array.isArray(results)) {
            EventBus.$emit('load_stop_list_data');
            return;
        }
        for (let i = 0; i < results.length; i++) {
            if (results[i].status && results[i].status === 'operation_fail') {
                errorOutput(__t('O.ERROR_GET_INFORMATION_FOR_STOP_LIST'), 'Error response' + results[i], 'stopListData');
                console.log('Error response', results[i]);
                continue;
            }

            if (i === 0) {
                if (Array.isArray(results[i].data)) {
                    state.selectAggregatorsLocationsRest = results[i].data;
                    state.selectAggregatorsLocationsRest.forEach((aggr, index) => {
                        aggr.isSelect = index === 0;
                        aggr.locations.forEach(location => location.isSelect = true);
                    })
                }
            }
            if (i === 1) {
                if (results[i].data) {
                    const resProducts = results[i].data;
                    if (resProducts.message && resProducts.message.total) {
                        state.stopListProductsTotal = resProducts.message.total;
                        state.stopListProductsTotalSizeScrollBlock = state.stopListProductsTotal * state.stopListProductsSizeItemBlock;
                    }
                    state.stopListProductsLoadCount = state.stopListChunkSize * 2;
                    state.stopListProducts = resProducts.data;
                    state.stopListProducts.forEach(item => item.isCheck = false);
                }
            }
        }
        EventBus.$emit('load_stop_list_data');
    },
    getStopListProductsWithoutFilter(state, params) {
        if (params.results && Array.isArray(params.results) && params.results.length > 0) {
            if (params.results[0].result && params.results[0].result.data && params.results[0].result.data.status === 'operation_success') {
                const result = params.results[0].result.data;

                if (result.filter && typeof result.filter === 'object') {
                    state.filterStopList = JSON.parse((JSON.stringify(result.filter)))
                    EventBus.$emit('loaded_filter_stop_list_products', state.filterStopList);
                }


                if (result.message && result.message.last_page) {
                    state.totalPagesStopListProducts = result.message.last_page;
                }

                if (result.message && result.message.current_page) {
                    state.filterStopList.activePage = result.message.current_page;
                }

                if (result.message && result.message.limit) {
                    state.limitEntriesOnPage = result.message.limit;
                }
                if (result.data && Array.isArray(result.data)) {
                    state.stopListProductsWithoutFilter = result.data;
                    state.stopListProductsWithoutFilter.forEach(item => item.isCheck = false);
                }
            } else {
                errorOutput(__t('O.FAILED_TO_GET_STOP_LIST_PRODUCTS'), 'Error response' + params.results[0].result.data.message, 'getStopListWithoutFilter');
                console.log('Error response', params.results[0].result.data.message);
            }
        }
        setStatesLoadingList(state, params);
    },
    stopListRestaurantsLocations(state, params) {
        EventBus.$emit('loaded_filter_restaurants_locations');
        setStatesLoadingList(state, params);
    },
    setSelectProductsStopList(state, productsList) {
        state.selectProductsStopList = productsList;
    },
    menuSearchProductsMenu(state, data) {
        state.searchProductsMenuStopList = data;
        state.searchProductsMenuStopList.forEach(item => item.isCheck = false);
        EventBus.$emit('load_search_products_menu');
    },
    setSearchDataStopListRest(state, searchData) {
        state.searchDataStopListRest = searchData;
    },
    setSearchDataStopListFast(state, searchData) {
        state.searchDataStopListFast = searchData;
    },
    setActiveItemStopListGroups(state, itemGroup) {
        state.activeItemStopListGroups = itemGroup;
    },
    setStatesLoadingList(state, params) {
        setStatesLoadingList(state, params);
    },
    getDataFilterStopList(state, params) {
        EventBus.$emit('loaded_stop_list_products_without_filter', state.filterStopList);
    },
    stopListProductsAction(state, params) {
        state.filterStopList.isFilter = true;
        EventBus.$emit('loaded_stop_list_products_without_filter', state.filterStopList);
    },
    setSelectAggregatorsLocationsAll(state, params){
        state.selectAggregatorsLocationsAll.forEach((item, index) =>{
            item.isSelect = index === 0;
            if(item.locations && Array.isArray(item.locations)){
                item.locations.forEach(location => location.isSelect = false)
            }
        })
        setStatesLoadingList(state, params);
    }
}

const getters = {
    getStopListField,
    getSelectAggregatorsLocationsRest(state) {
        return state.selectAggregatorsLocationsRest;
    },
    getStopListProducts(state) {
        return state.stopListProducts;
    },
    getSelectProductsStopList(state) {
        return state.selectProductsStopList;
    },
    getSearchProductsMenuStopList(state) {
        return state.searchProductsMenuStopList;
    },
    getSearchDataStopListRest(state) {
        return state.searchDataStopListRest;
    },
    getSearchDataStopListFast(state) {
        return state.searchDataStopListFast;
    },
    getStopListProductsFilter(state) {
        return state.stopListProductsFilter;
    },
    getStopListGroups(state) {
        return state.stopListGroups;
    },
    getActiveItemStopListGroups(state) {
        return state.activeItemStopListGroups;
    },
    getIsLoadedStopListProductsWithoutFilter(state) {
        return state.isLoadedStopListProductsWithoutFilter;
    },
    getIsLoadedStopListRestaurantsLocations(state) {
        return state.isLoadedStopListRestaurantsLocations;
    },
    getStopListFilterRestaurantsLocations(state) {
        return state.stopListFilterRestaurantsLocations;
    },
    getTotalPagesStopListProducts(state) {
        return state.totalPagesStopListProducts;
    },
    getFilterStopList(state) {
        return state.filterStopList;
    },
    getSelectAggregatorsLocationsAll(state) {
        return state.selectAggregatorsLocationsAll;
    },
    getIsLoadedSelectAggregatorsLocationsAll(state) {
        return state.isLoadedSelectAggregatorsLocationsAll;
    }
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
